import { createThirdwebClient } from "thirdweb";
import { generateAccount } from "thirdweb/wallets";
import { inAppWallet } from "thirdweb/wallets/in-app";

const clientId = process.env.REACT_APP_TEMPLATE_CLIENT_ID;
const secretKey = process.env.THIRDWEB_SECRET_KEY;

export const client = createThirdwebClient(
    secretKey
        ? { secretKey }
        : {
              clientId,
          },
);

// Generate account and export the private key string
const account = generateAccount({ client });
export const privateKey = account.privateKey; // Extract just the private key

export const wallets = [
    inAppWallet({
        auth: {
            options: ["google", "apple", "facebook", "email"],
        },
    }),
];
